const { loadJavaScript } = require("../utils/common");
const { caloDebugLog } = require("../utils/debug");
const { getThinUuid } = require("../utils/common");

// Auto-initialize external tracking when this module is imported
// This ensures tracking works even if someone directly imports paySuccess, openEmail, etc.
if (typeof window !== 'undefined' && !window.__EXTERNAL_TRACKING_INITIALIZED__) {
    window.__EXTERNAL_TRACKING_INITIALIZED__ = true;
    
    // Initialize asynchronously without blocking module loading
    Promise.resolve().then(() => {
        initExternalTracking().catch(error => {
            console.error("Failed to auto-initialize external tracking:", error);
        });
    });
}

function loadTT() {
  !(function (w, d, t) {
    w.TiktokAnalyticsObject = t;
    var ttq = (w[t] = w[t] || []);
    (ttq.methods = [
      "page",
      "track",
      "identify",
      "instances",
      "debug",
      "on",
      "off",
      "once",
      "ready",
      "alias",
      "group",
      "enableCookie",
      "disableCookie",
      "holdConsent",
      "revokeConsent",
      "grantConsent",
    ]),
      (ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      });
    for (var i = 0; i < ttq.methods.length; i++)
      ttq.setAndDefer(ttq, ttq.methods[i]);
    (ttq.instance = function (t) {
      for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)
        ttq.setAndDefer(e, ttq.methods[n]);
      return e;
    }),
      (ttq.load = function (e, n) {
        var r = "https://analytics.tiktok.com/i18n/pixel/events.js",
          o = n && n.partner;
        (ttq._i = ttq._i || {}),
          (ttq._i[e] = []),
          (ttq._i[e]._u = r),
          (ttq._t = ttq._t || {}),
          (ttq._t[e] = +new Date()),
          (ttq._o = ttq._o || {}),
          (ttq._o[e] = n || {});
        n = document.createElement("script");
        (n.type = "text/javascript"),
          (n.async = !0),
          (n.src = r + "?sdkid=" + e + "&lib=" + t);
        e = document.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(n, e);
      });

    ttq.load("D1DQK3BC77U8IVAAJ4Q0");
    ttq.page();
  })(window, document, "ttq");
}
function loadFB() {
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    "script",
    "https://connect.facebook.net/en_US/fbevents.js"
  );
  fbq("init", "728134713502718");
  fbq("track", "PageView");
}
export function gtag() {
  let args = Array.prototype.slice.call(arguments);
  if (args && args.length > 0 && args[0] == "event") {
    let str = `${JSON.stringify(arguments)}`;
    // 发送gtag埋点
    if (window.track && window.track.logEvent) {
      window.track.logEvent("gtag_show", {
        string1: str,
      });
    }

    caloDebugLog("gtag event", str);
  }
  window?.dataLayer?.push(arguments);
}

const loadGA = async () => {
  window.dataLayer = window.dataLayer || [];
  gtag("js", new Date());
  gtag("config", "AW-17159145026");
  await loadJavaScript(
    "https://www.googletagmanager.com/gtag/js?id=AW-17159145026"
  );
};

export const loadExternalTracking = async () => {
  loadTT();
  loadFB();
  await loadGA();
};

export const initExternalTracking = async () => {
  await loadExternalTracking();
  openView();
};

export const openView = () => {
  if (window.ttq) {
    window.ttq.track("ViewContent");
  }
  gtag("event", "conversion", {
    send_to: "AW-17159145026/kuvOCNLeruIaEMKMj_Y_",
  });
};
export const openEmail = () => {
  if (window.ttq) {
    window.ttq.identify({});
  }
  if (window.fbq) {
    window.fbq("trackCustom", "email_open", {});
  }
  gtag("event", "conversion", {
    send_to: "AW-17159145026/UFIACMneruIaEMKMj_Y_",
  });
};

export const paySuccess = (value, currency) => {
  if (window.ttq) {
    ttq.track("Purchase", {
      value: value, // number. Value of the order or items sold. Example: 100.
      currency: currency, // string. The 4217 currency code. Example: "USD".
    });
  }
  if (window.fbq) {
    trackFBPurchaseEvent({ currency, value });
    trackFBCustomEvent({ event: "web_subscribe", data: { value: value, currency: currency } });
  }
  gtag("event", "conversion", {
    send_to: "AW-17159145026/9daQCJvOruIaEMKMj_Y_",
    value: value,
    currency: currency,
  });
};

export const landingAgeSelect = () => {
    trackFBCustomEvent({ event: "landingpage_selectage_click" });
}

const trackFBCustomEvent = ({ event, data }) => {
    if (window.fbq) {
        let eventId = getThinUuid();
        window.fbq("trackCustom", event, data || {}, { eventID: eventId });
    }
}

const trackFBPurchaseEvent = ({ currency, value }) => {
    if (window.fbq) {
        let eventId = getThinUuid();
        window.fbq("track", "Purchase", { currency, value }, { eventID: eventId });
    }
}